import { OptionDto } from "@/dtos";
import { TelephoneOperatorStatus } from "@/helpers/types";

const operators = [
    { value: parseInt(TelephoneOperatorStatus.CLARO), label: 'Claro' },
    { value: parseInt(TelephoneOperatorStatus.MOVISTAR), label: 'Movistar' },
    { value: parseInt(TelephoneOperatorStatus.CNT), label: 'CNT' },
    { value: parseInt(TelephoneOperatorStatus.TUENTI), label: 'Tuenti' },
] as OptionDto[];


export const getChipOperatorOptions = (): OptionDto[] => {
    return operators;
}

export const getChipOperatorOption = (value: number): OptionDto => {
    return operators.find((x) => x.value == value) ?? operators[0];
}

export const getChipOperator = (value: number): TelephoneOperatorStatus => {
    switch (value) {
        case 1001:
            return TelephoneOperatorStatus.CLARO;
        case 1002:
            return TelephoneOperatorStatus.MOVISTAR;
        case 1003:
            return TelephoneOperatorStatus.CNT;
        case 1004:
            return TelephoneOperatorStatus.TUENTI;
        default:
            return TelephoneOperatorStatus.CLARO;
    }
}